import React, { useState, useEffect } from 'react';
import './Vinilos.css';

const Vinilos = () => {
  const [nombre, setNombre] = useState('');
  const [especificacion, setEspecificacion] = useState('');
  const [hover, setHover] = useState(false);

  // Preload de la imagen hover para evitar parpadeos
  useEffect(() => {
    const img = new Image();
    img.src = '/images/mockup-vinilo-hover.jpg';
  }, []);

  const handleWhatsAppRedirect = () => {
    const mensaje = `Hola! Quisiera consultar por el servicio de *Vinilos para paredes*.\n\nMi nombre es: ${nombre}\n\nEspecificaciones: ${especificacion}`;
    const url = `https://wa.me/5491160035550?text=${encodeURIComponent(mensaje)}`;
    window.open(url, '_blank');
  };

  const backgroundStyle = {
    backgroundImage: 'url("/images/vinilo.jpg")',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundAttachment: 'fixed',
    position: 'relative',
    width: '100%',
    height: '100%',
  };

  return (
    <div style={backgroundStyle} className='vinilos-bg'>
      <div style={{
        backgroundColor: 'rgba(237, 232, 227, 0.85)',
        backdropFilter: 'blur(1px)',
        minHeight: '100vh',
        paddingBottom: '2rem',
      }}>
        <div className="vinilos-header">
          <h1 className="vinilos-title">Vinilos para pared</h1>
          <p className="vinilos-description">
            Ofrecemos un servicio personalizado de vinilos para pared, ideal para decorar tus espacios con diseños únicos y hechos a medida. Usamos materiales de alta calidad y acompañamos todo el proceso creativo, desde la idea hasta la instalación.
          </p>
        </div>

        <div className="imagen-descentrada">
          <img
            src={hover ? "/images/mockup-vinilo-hover.jpg" : "/images/mockup-vinilos.jpg"}
            alt="Juani en acción"
            onMouseEnter={() => setHover(true)}
            onMouseLeave={() => setHover(false)}
          />
        </div>

        <div className="vinilos-container">
          {/* NUEVO: Cómo funciona */}
          <div className="vinilos-pasos">
            <h2>¿Cómo funciona?</h2>
            <div className="pasos-grid">
              <div className="paso">
                <span className="paso-num">1</span>
                <p>Enviás tu idea o medidas</p>
              </div>
              <div className="paso">
                <span className="paso-num">2</span>
                <p>Te mandamos una propuesta visual</p>
              </div>
              <div className="paso">
                <span className="paso-num">3</span>
                <p>Confirmás el diseño</p>
              </div>
              <div className="paso">
                <span className="paso-num">4</span>
                <p>¡Producimos y te lo enviamos!</p>
              </div>
            </div>
          </div>

          {/* NUEVO: CTA final */}
          <div className="vinilos-cta-final">
            <h2>¿Tenés una pared en blanco?</h2>
            <p>Transformala en una obra de arte con un vinilo personalizado.</p>
            <div className="vinilos-form">
              <input
                type="text"
                placeholder="Tu nombre"
                value={nombre}
                onChange={(e) => setNombre(e.target.value)}
              />
              <textarea
                placeholder="Especificaciones del vinilo que querés"
                value={especificacion}
                onChange={(e) => setEspecificacion(e.target.value)}
              />
            </div>
            <button onClick={handleWhatsAppRedirect}>Consultá ahora</button>
          </div>
        </div>
      </div>
    </div >
  );
};

export default Vinilos;
